export enum ActionFormTabsPages {
  About = 0,
  Media = 1,
  Where = 2,
}
